module.exports = __webpack_public_path__ + "img/no-image-available.d704bd89.jpg";